// ==============================|| FINANCIAL CONDIITON TYPES ||============================== //

import { Company } from './companies';
import { NamedEntityMinDto } from './other';

export enum FinancialConditionScopeType {
    COMPANY = 'COMPANY',
    CONTRACT = 'CONTRACT',
}

export interface FinancialCondition {
    id: number;
    scopeTypeCode: string;
    company?: NamedEntityMinDto;
    contract?: {
        id: number;
    };
    paymentDeadlineInDays?: number;
    prepaymentPaymentDeadlineInDays?: number;
    invoicingIntervalTypeCode?: string;
    casesDefaultFeeArrangementTypeCode?: string | null;
    interestRatePct?: string;
    interestRateB2cPct?: string;
    currencyTypeCode?: string;
}

export interface FinancialConditionCreateDto {
    scopeTypeCode: FinancialConditionScopeType;
    companyId: number | null;
    contractId: number | null;
    paymentDeadlineInDays: number | null;
    prepaymentPaymentDeadlineInDays: number | null;
    invoicingIntervalTypeCode: string | null;
    casesDefaultFeeArrangementTypeCode: string | null;
    interestRatePct: string | null;
    interestRateB2cPct: string | null;
    currencyTypeCode: string | null;
    company?: Partial<Company>;
}

export interface FinancialConditionUpdateDto extends FinancialConditionCreateDto {
    id: string | number;
}

export interface FinancialConditionForm {
    scopeTypeCode: FinancialConditionScopeType;
    companyId: number | null;
    contractId: number | null;
    paymentDeadlineInDays: number;
    prepaymentPaymentDeadlineInDays: number | null;
    interestRatePct: string;
    interestRateB2cPct: string;
    invoicingIntervalType: { label: string; value: string } | null;
    casesDefaultFeeArrangementType: { label: string; value: string } | null;
    currencyType: { label: string; value: string } | null;
    company:
        | (Omit<Company, 'countryCode' | 'customDateFormat'> & {
              countryCode: { label: string; value: string } | null;
              dateOrder: { label: string; value: string } | null;
              dateSeparator: { label: string; value: string } | null;
          })
        | null;
}
